var Vehicles = {

    get: function (parameters, callback) {
        $.ajax({
            url: '/api/vehicles',
            method: 'GET',
            data: parameters,
            success: function (result) {
                if (result.success) {
                    return callback(result.data);
                }
                
                callback();
            },
            error: function () {
                callback();
            }
        });
    }

};

module.exports = Vehicles;